import configDefault from "./config-default";

const config = {
  ...configDefault,
  code: "fitinparis.fr",
  favicon: "/fitinparis-favicon.png",
  title: "Je m'inscris | Fit'in Paris",
  companyName: "Fit'in Paris",
  website: "https://fitinparis.fr/",
  notifyChannel: "vel-fitinparis",
  header: {
    title: "Je m'abonne",
    logo: "/fitinparis-header-logo.png",
    urlLogo: "https://fitinparis.fr/",
  },
  footer: {
    logo: "/fitinparis-footer-logo.png",
    textLine: "SAS IT FIT, RCS 978 482 248, 31 quai André Citroën, 75015 Paris, exploitant le club de fitness sous l'enseigne « Fit'in Paris »",
    // Le club doit publier ses CGV sur son propre site (pas encore en ligne).
    // Lien masqué en attendant, plutôt que d'hériter du lien de démo de
    // config-default. Le lien d'optin peut aussi venir du BO VEL via
    // club.optin_href.
    cgv: null,
  },
  payByCard: "STRIPE",
};

export default config;
